module.exports = __webpack_public_path__ + "static/white_DDD_logo-ece3360dbaf82bbbde13ee07ea8bfb9e.jpg";